export const GET_PROFILECONFIG_ACTIVE_REQUEST = 'GET_PROFILECONFIG_ACTIVE_REQUEST'
export const GET_PROFILECONFIG_ACTIVE_SUCCESS = 'GET_PROFILECONFIG_ACTIVE_SUCCESS'
export const GET_PROFILECONFIG_ACTIVE_FAIL = 'GET_PROFILECONFIG_ACTIVE_FAIL'
